import { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Button } from "@atoms"
import Loader from "components/loader"
import useQueryParams from "utils/useQueryParams"
import { useConfirmEmailChange } from "./queries"
import { dispatchLoggedOutEvent } from "providers/auth"

const EmailChangeConfirm = () => {
  const { t } = useTranslation("profile")
  const navigate = useNavigate()
  const params = useQueryParams()
  const confirmEmailChange = useConfirmEmailChange()
  const hasConfirmed = useRef(false)

  useEffect(() => {
    if (hasConfirmed.current) return
    hasConfirmed.current = true

    confirmEmailChange.mutate(
      {
        user: params.user as string,
        email: params.email as string,
        signature: params.signature as string,
        expires: params.expires as string,
      },
      {
        onSuccess: () => {
          dispatchLoggedOutEvent();
        },
      }
 
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (confirmEmailChange.isLoading) {
    return <Loader />
  }

  return (
    <div>
      <h1 className="headline-heavy">{t("emails.confirmTitle")}</h1>
      <p className="body">
        {confirmEmailChange.isSuccess
          ? t("emails.confirmSuccess")
          : t("emails.confirmError")}
      </p>
      <Button color="primary" onClick={() => navigate("/auth/sign-in")}>
        {t("emails.backToLogin")}
      </Button>
    </div>
  )
}

export default EmailChangeConfirm
